import React from 'react';

import { Header } from '~/components/modules/Header/Header';

const HeaderContainer: React.FC<{ blank?: boolean }> = ({ blank }) => {
    return <Header blank={blank} />;
};

export default HeaderContainer;
